// src/pages/public/BlogPage.jsx
import { Link, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { Calendar } from 'lucide-react'
import { cmsPublicApi as cmsApi } from '../../api/services'
import { PageSpinner, Pagination } from '../../components/common/ui'

export default function BlogPage() {
  const [sp, setSp] = useSearchParams()
  const page = parseInt(sp.get('page') || '1')

  const { data, isLoading } = useQuery({
    queryKey: ['blog', page],
    queryFn: () => cmsApi.blog({ page }),
  })

  const posts = data?.data?.data?.data || []
  const lastPage = data?.data?.data?.last_page || 1

  return (
    <div className="max-w-4xl mx-auto px-4 py-10">
      <div className="mb-8">
        <h1 className="text-3xl font-display font-bold text-gray-900">Fabrinza Blog</h1>
        <p className="text-muted mt-2">Industry insights, fabric guides, and textile trends.</p>
      </div>

      {isLoading && <PageSpinner />}

      <div className="grid gap-6">
        {posts.map(post => (
          <Link key={post.id} to={`/blog/${post.slug}`} className="group bg-white border border-border rounded-2xl overflow-hidden hover:border-pink hover:shadow-md transition-all flex gap-0 sm:flex-row flex-col">
            {post.featured_image && (
              <div className="sm:w-56 h-40 flex-shrink-0 overflow-hidden">
                <img src={post.featured_image} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
              </div>
            )}
            <div className="p-5 flex flex-col justify-center">
              <div className="flex items-center gap-2 text-xs text-muted mb-2">
                <Calendar size={12} />
                {post.published_at ? new Date(post.published_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : ''}
                {post.author_name && <><span>·</span><span>{post.author_name}</span></>}
              </div>
              <h2 className="text-lg font-display font-bold text-gray-900 group-hover:text-pink transition-colors line-clamp-2">{post.title}</h2>
              {post.excerpt && <p className="text-sm text-gray-600 mt-1.5 line-clamp-2">{post.excerpt}</p>}
            </div>
          </Link>
        ))}
      </div>

      {!isLoading && posts.length === 0 && <p className="text-center text-muted py-16">No posts yet.</p>}

      {lastPage > 1 && (
        <div className="mt-8">
          <Pagination currentPage={page} lastPage={lastPage} onPageChange={p => setSp({ page: p })} />
        </div>
      )}
    </div>
  )
}
